import ServiceBgImg1 from "../src/images/1.png";
import ServiceBgImg2 from "../src/images/2.png";
import ServiceBgImg3 from "../src/images/3.png";
import Service1 from "../src/images/svg/service1.svg";
import Service2 from "../src/images/svg/service2.svg";
import Service3 from "../src/images/svg/service3.svg";

const Sdataprocess = [
  {
    imgurl: ServiceBgImg1,
    svgbg: Service1,
    title: 'Pixel Perfect',
    desc: 'Most common methods for designing websites that work well on desktop is responsive and adaptive design.',
  },

  {
    imgurl: ServiceBgImg2,
    svgbg: Service2,
    title: 'High Quality',
    desc: 'Most common methods for designing websites that work well on desktop is responsive and adaptive design.',
  },

  {
    imgurl: ServiceBgImg3,
    svgbg: Service3,
    title: 'Awesome Idea',
    desc: 'Most common methods for designing websites that work well on desktop is responsive and adaptive design',
  },

];

export default Sdataprocess;